export const FROM_SUPERAPP = 'mm2';
